module.exports = __webpack_public_path__ + "static/media/brasao.e494613a.svg";